import React, { useRef } from "react";
import { Line, Rect } from "react-konva";

const MastColumnNone = ({ lanterns, position, props, circleRadius, colorList, luminaires, fullArmLength, endPointSize }) => {
  const lineRefs = useRef([]);

  return lanterns.map((lantern, idx) => {
    if (!lineRefs.current[idx]) lineRefs.current[idx] = React.createRef();
    const lineRef = lineRefs.current[idx];

    const baseAngle = parseFloat(props.positionAngle) + lantern.positionAngle;
    const angleRad = ((baseAngle + 90) * Math.PI) / 180;
    const outreach = props.values.useLanternOutreach ? lantern.outreach : props.values.outreach || 0;
    const effectiveArmLength = fullArmLength * Math.max(1, outreach);
    const rectArmLength = fullArmLength * Math.max(0, outreach);
    const armTipX = position.x + effectiveArmLength * Math.cos(angleRad);
    const armTipY = position.y + effectiveArmLength * Math.sin(angleRad);
    const rectX = position.x + rectArmLength * Math.cos(angleRad);
    const rectY = position.y + rectArmLength * Math.sin(angleRad);

    const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
    const resolvedColor = luminaireIndex !== -1 && colorList[luminaireIndex] ? colorList[luminaireIndex] : "lightgray";

    return (
      <React.Fragment key={idx}>
        <Line
          ref={lineRef}
          points={[position.x, position.y, armTipX, armTipY]}
          stroke={resolvedColor === "#FFA500 " ? "orange" : resolvedColor}
          strokeWidth={circleRadius / 5}
        />
        <Rect
          x={rectX}
          y={rectY}
          width={endPointSize}
          height={endPointSize}
          fill={resolvedColor === "#FFA500 " ? "orange" : resolvedColor}
          rotation={baseAngle}
          offset={{ x: endPointSize / 2, y: endPointSize / 2 }}
          draggable={props.selected}
          onDragMove={(e) => {
            const { x: dragX, y: dragY } = e.target.position();
            const dx = dragX - position.x;
            const dy = dragY - position.y;
            const angleRad = Math.atan2(dy, dx);
            const angleDeg = (angleRad * 180) / Math.PI;

            const fixedX = position.x + effectiveArmLength * Math.cos(angleRad);
            const fixedY = position.y + effectiveArmLength * Math.sin(angleRad);
            const adjustedAngle = (angleDeg + 360) % 360;

            e.target.position({ x: fixedX, y: fixedY });
            e.target.rotation(parseFloat(adjustedAngle).toFixed(3));
            e.target.getLayer().batchDraw();

            if (lineRef.current) {
              const lineX = position.x + effectiveArmLength * Math.cos(angleRad);
              const lineY = position.y + effectiveArmLength * Math.sin(angleRad);
              lineRef.current.points([position.x, position.y, lineX, lineY]);
              lineRef.current.getLayer().batchDraw();
            }
          }}

          onDragEnd={(e) => {
            const { x: dragX, y: dragY } = e.target.position();
            const dx = dragX - position.x;
            const dy = dragY - position.y;
            let angleDeg = (Math.atan2(dy, dx) * 180) / Math.PI;
            angleDeg = (angleDeg - props.positionAngle - 90 + 360) % 360;
            props.updateLanternRotation(parseFloat(angleDeg.toFixed(3)), null, props.i, idx);
          }}
        />
      </React.Fragment>
    );
  });
};

export default MastColumnNone;
